// 多语言翻译配置
export const translations = {
  zh: {
    langName: "简体中文",
    appTitle: "CharGen",
    appSubtitle: "Beta",
    heroSubtitle: "输入灵感碎片，锻造完整灵魂。",
    modeCustom: "定制模式",
    modeRandom: "完全随机",
    labelWorld: "世界观架构",
    labelRole: "职业/身份",
    labelGender: "性别",
    labelKeywords: "补充线索",
    labelSubversion: "角色反套路程度",
    subversionOptions: {
      ordinary: "平平无奇 - 完全符合职业刻板印象",
      surprising: "有点意外 - 有一两个小反差",
      memorable: "印象深刻 - 明显的内在矛盾",
      unconventional: "离经叛道 - 强烈颠覆预期",
      extreme: "极度反叛 - 彻底打破常规"
    },
    placeholderRole: "例：流浪骑士",
    placeholderGender: "例：女",
    placeholderKeywords: "例：有点神经质，喜欢收集旧硬币...",
    placeholderApiKey: "粘贴 API Key",
    placeholderModel: "输入完整模型名称，如 gemini-2.0-flash",
    randomText: "一切交给命运。\n系统将为你从零构建一个独特的灵魂。",
    btnGenerate: "开始锻造",
    btnConfigureApiKey: "请先配置 API Key ⚙️",
    btnGenerating: "生成中...",
    errorApiKey: "请先点击右上角设置图标，配置 API Key。",
    currentModel: "当前模型:",
    waitingTitle: "等待输入",
    waitingDesc: "请先点击右上角的齿轮图标配置模型参数，然后开始生成。",
    loadingText: "正在构建神经回路...",
    loadingProvider: "调用接口:",
    tabCard: "角色档案",
    tabSysPrompt: "角色指令",
    tabPrompt: "绘图咒语",
    tabJson: "JSON 数据",
    secPsychology: "心理侧写",
    labelMbti: "MBTI",
    labelDesire: "欲望",
    labelFear: "恐惧",
    labelHighConcept: "高概念",
    labelQuirks: "怪癖",
    secAppearance: "外貌特征",
    secBackground: "背景故事",
    labelSecret: "不可告人的秘密",
    labelSysPrompt: "LLM System Instruction",
    labelDevGuide: "开发者指南",
    textDevGuide: "这段指令专门用于配置 LLM（如 GPT-4, Claude, 或游戏中的 AI 角色）。将其粘贴到 AI 的 System Prompt（或 System Message）字段中，AI 就会立刻'变成'这个角色，并严格遵循其性格、口吻和背景知识与用户对话。",
    btnCopy: "复制",
    btnCopied: "已复制",
    btnDownloadMd: "下载 Markdown",
    btnDownloaded: "已下载",
    // Markdown 导出专用
    mdBasicInfo: "基本信息",
    mdAttrHeader: "属性",
    mdValueHeader: "值",
    mdRace: "种族",
    mdGender: "性别",
    mdAge: "年龄",
    mdOccupation: "职业",
    mdAlignment: "阵营",
    mdCoreDesire: "核心欲望",
    mdCoreFear: "核心恐惧",
    mdFlaw: "性格缺陷",
    mdPersonalityKeywords: "性格关键词",
    mdOrigin: "出身地",
    mdUnknown: "未知",
    mdSecretWarning: "⚠️",
    mdCharacterSection: "角色指令 (System Prompt)",
    mdImageSection: "绘图咒语 (Image Prompt)",
    mdJsonSection: "原始 JSON 数据",
    mdGeneratedBy: "由 CharGen 生成",
    mdGenerateFailed: "生成失败",
    // Visual Design Studio
    visualStudioTitle: "视觉设计室",
    visualUsageGuide: "💡 使用指南",
    visualUsageGuideText: "① 复制「角色立绘」提示词到 Gemini/MJ/SD 生成立绘图 → ② 将生成的图片作为参考图，配合后续提示词模板（三视图、深度分解等）逐步构建完整设定集。",
    visualStyleNotice: "🎨 风格说明",
    visualStyleNoticeText: "默认生成通用游戏概念艺术风格（类似守望先锋/英雄联盟）。如需动漫风格，请在角色生成时的'补充线索'中添加「anime style」关键词。",
    visualTypes: {
      portrait: "角色立绘",
      three_views: "三视图",
      concept_breakdown: "深度分解",
      expression_sheet: "表情图谱",
      scale_chart: "比例对比",
      action_poses: "动态姿态"
    },
    visualDescriptions: {
      portrait: "标准角色肖像，强调光影与面部细节。",
      three_views: "正/侧/背三视图，用于 3D 建模参考。",
      concept_breakdown: "服装分层、武器道具与材质特写。",
      expression_sheet: "多角度面部表情，展现喜怒哀乐。",
      scale_chart: "身高比例尺对比，确立体型数据。",
      action_poses: "高张力战斗或动作姿态，展示动态剪影。"
    },
    btnGenerateVisual: "生成提示词",
    msgVisualGenerating: "正在设计...",
    msgConsistency: "基于【角色立绘】生成，保持外观一致 ✨",
    guideRefPortrait: "使用技巧：请将【01. 角色立绘】生成的图片作为参考图 (Reference Image) 上传给 AI，并配合下方提示词使用。",
    guideRefSheet: "使用技巧：推荐将【02. 三视图】生成的图片作为参考图（结构更准确），或继续使用立绘。",
    labelImgPrompt: "Stable Diffusion / Midjourney Prompt",
    textImgGuide: "这个 Prompt 是为了生成角色立绘而优化的。你可以直接将其粘贴到 Midjourney（使用 /imagine 指令）或 Stable Diffusion 的 WebUI 中。如果需要特定风格（如二次元），可以在末尾手动添加 \"anime style\" 或 \"realistic\"。",
    labelRawJson: "Raw JSON Data",
    settingsTitle: "模型配置",
    labelProvider: "AI 提供商 (Provider)",
    labelApiKey: "API Key",
    labelBaseUrl: "代理地址 / Base URL",
    labelModel: "模型名称 (Model Name)",
    localOllama: "本地 Ollama",
    modelHint: "提示：请从官方文档复制准确的模型名称",
    btnTest: "测试连接",
    btnSave: "保存并关闭",
    statusConnected: "连接成功",
    statusFailed: "连接失败",
    statusTesting: "测试中...",
    worldOptionCustom: "其他 (手动输入)",
    placeholderCustomWorld: "例：蒸汽朋克+克苏鲁、校园日常、古罗马竞技场...",
    worldOptions: {
      fantasy: "奇异 (Fantasy) - 剑与魔法，龙与地下城",
      cyberpunk: "赛博朋克 (Cyberpunk) - 高科技低生活",
      modern: "现代都市 (Modern) - 现实主义/悬疑",
      space: "太空歌剧 (Space Opera) - 星际旅行",
      wasteland: "末日废土 (Post-Apocalyptic) - 辐射与生存",
      wuxia: "东方武侠/仙侠 (Wuxia/Xianxia) - 江湖修仙",
      lovecraft: "克苏鲁神话 (Lovecraftian) - 不可名状之恐惧"
    }
  },
  en: {
    langName: "English",
    appTitle: "CharGen",
    appSubtitle: "Beta",
    heroSubtitle: "Input fragments, forge a complete soul.",
    modeCustom: "Custom Mode",
    modeRandom: "Random Mode",
    labelWorld: "World Setting",
    labelRole: "Role/Identity",
    labelGender: "Gender",
    labelKeywords: "Keywords/Clues",
    labelSubversion: "Character Subversion Level",
    subversionOptions: {
      ordinary: "Ordinary - Fits the stereotype perfectly",
      surprising: "Surprising - One or two small twists",
      memorable: "Memorable - Clear inner contradictions",
      unconventional: "Unconventional - Strongly defies expectations",
      extreme: "Extreme Rebel - Completely breaks the mold"
    },
    placeholderRole: "e.g. Wandering Knight",
    placeholderGender: "e.g. Female",
    placeholderKeywords: "e.g. Neurotic, collects old coins...",
    placeholderApiKey: "Paste API Key",
    placeholderModel: "Enter full model name, e.g. gemini-2.0-flash",
    randomText: "Leave it to fate.\nThe system will build a unique soul from scratch.",
    btnGenerate: "Start Forging",
    btnConfigureApiKey: "Configure API Key First ⚙️",
    btnGenerating: "Forging...",
    errorApiKey: "Please configure API Key in settings first.",
    currentModel: "Current Model:",
    waitingTitle: "Waiting for Input",
    waitingDesc: "Please configure model settings via the gear icon first.",
    loadingText: "Building neural circuits...",
    loadingProvider: "Provider:",
    tabCard: "Profile",
    tabSysPrompt: "Character Prompt",
    tabPrompt: "Image Prompt",
    tabJson: "JSON Data",
    secPsychology: "Psychology",
    labelMbti: "MBTI",
    labelDesire: "Desire",
    labelFear: "Fear",
    labelHighConcept: "High Concept",
    labelQuirks: "Quirks",
    secAppearance: "Appearance",
    secBackground: "Background",
    labelSecret: "Dark Secret",
    labelSysPrompt: "LLM System Instruction",
    labelDevGuide: "Developer Guide",
    textDevGuide: "This instruction is designed for LLMs (GPT-4, Claude, or game AI characters). Paste it into the System Prompt field, and the AI will immediately 'become' this character, following its personality and background.",
    btnCopy: "Copy",
    btnCopied: "Copied",
    btnDownloadMd: "Download MD",
    btnDownloaded: "Downloaded",
    // Markdown export
    mdBasicInfo: "Basic Info",
    mdAttrHeader: "Attribute",
    mdValueHeader: "Value",
    mdRace: "Race",
    mdGender: "Gender",
    mdAge: "Age",
    mdOccupation: "Occupation",
    mdAlignment: "Alignment",
    mdCoreDesire: "Core Desire",
    mdCoreFear: "Core Fear",
    mdFlaw: "Character Flaw",
    mdPersonalityKeywords: "Personality Keywords",
    mdOrigin: "Origin",
    mdUnknown: "Unknown",
    mdSecretWarning: "⚠️",
    mdCharacterSection: "Character Instruction (System Prompt)",
    mdImageSection: "Image Prompt",
    mdJsonSection: "Raw JSON Data",
    mdGeneratedBy: "Generated by CharGen",
    mdGenerateFailed: "Generation failed",
    // Visual Design Studio
    visualStudioTitle: "Visual Studio",
    visualUsageGuide: "💡 Usage Guide",
    visualUsageGuideText: "① Copy the 'Portrait' prompt to Gemini/MJ/SD to generate the character portrait → ② Use the generated image as a reference, then apply subsequent prompt templates (Three Views, Concept Breakdown, etc.) to build a complete character design sheet.",
    visualStyleNotice: "🎨 Style Note",
    visualStyleNoticeText: "Default style: Universal game concept art (similar to Overwatch/League of Legends). For anime style, add \"anime style\" to Keywords when generating the character.",
    visualTypes: {
      portrait: "Portrait",
      three_views: "Three Views",
      concept_breakdown: "Concept Breakdown",
      expression_sheet: "Expression Sheet",
      scale_chart: "Scale Chart",
      action_poses: "Action Poses"
    },
    visualDescriptions: {
      portrait: "Standard character portrait",
      three_views: "Front/Side/Back turnaround",
      concept_breakdown: "Costume layers & prop details",
      expression_sheet: "Multi-angle facial expressions",
      scale_chart: "Height comparison chart",
      action_poses: "Dynamic combat poses"
    },
    btnGenerateVisual: "Generate Prompt",
    msgVisualGenerating: "Designing...",
    msgConsistency: "Based on [Portrait] for consistent appearance ✨",
    guideRefPortrait: "Usage Tip: Upload the [01. Portrait] image as a reference image to the AI along with the prompt below.",
    guideRefSheet: "Usage Tip: Recommended to use [02. Three Views] as reference (more structurally accurate), or continue using the portrait.",
    labelImgPrompt: "Stable Diffusion / Midjourney Prompt",
    textImgGuide: "This prompt is optimized for character illustration. Paste it directly into Midjourney (/imagine) or Stable Diffusion WebUI. Add 'anime style' or 'realistic' at the end for specific styles.",
    labelRawJson: "Raw JSON Data",
    settingsTitle: "Model Settings",
    labelProvider: "AI Provider",
    labelApiKey: "API Key",
    labelBaseUrl: "Base URL",
    labelModel: "Model Name",
    localOllama: "Local Ollama",
    modelHint: "Tip: Copy the exact model name from official docs",
    btnTest: "Test Connection",
    btnSave: "Save & Close",
    statusConnected: "Connected",
    statusFailed: "Failed",
    statusTesting: "Testing...",
    worldOptionCustom: "Other (Manual Input)",
    placeholderCustomWorld: "e.g. Steampunk + Lovecraft, School Life, Ancient Rome...",
    worldOptions: {
      fantasy: "Fantasy - Sword & Magic, D&D",
      cyberpunk: "Cyberpunk - High Tech Low Life",
      modern: "Modern - Realistic/Mystery",
      space: "Space Opera - Interstellar Travel",
      wasteland: "Post-Apocalyptic - Radiation & Survival",
      wuxia: "Wuxia/Xianxia - Martial Arts & Cultivation",
      lovecraft: "Lovecraftian - Cosmic Horror"
    }
  },
  es: {
    langName: "Español",
    appTitle: "CharGen",
    appSubtitle: "Beta",
    heroSubtitle: "Ingresa fragmentos, forja un alma completa.",
    modeCustom: "Personalizado",
    modeRandom: "Aleatorio",
    labelWorld: "Entorno",
    labelRole: "Rol/Identidad",
    labelGender: "Género",
    labelKeywords: "Palabras clave",
    labelSubversion: "Nivel de subversión",
    subversionOptions: {
      ordinary: "Ordinario - Cumple el estereotipo",
      surprising: "Sorprendente - Uno o dos giros",
      memorable: "Memorable - Contradicciones claras",
      unconventional: "Poco convencional - Desafía expectativas",
      extreme: "Rebelde extremo - Rompe el molde"
    },
    placeholderRole: "ej. Caballero errante",
    placeholderGender: "ej. Mujer",
    placeholderKeywords: "ej. Neurótico, colecciona monedas...",
    placeholderApiKey: "Pegar clave API",
    placeholderModel: "Ingrese el nombre completo del modelo, ej. gemini-2.0-flash",
    randomText: "Déjalo al destino.\nEl sistema construirá un alma única desde cero.",
    btnGenerate: "Empezar",
    btnConfigureApiKey: "Configure la API Key primero ⚙️",
    btnGenerating: "Generando...",
    errorApiKey: "Configura la API Key en ajustes primero.",
    currentModel: "Modelo actual:",
    waitingTitle: "Esperando entrada",
    waitingDesc: "Configura el modelo en el icono de engranaje primero.",
    loadingText: "Construyendo circuitos neuronales...",
    loadingProvider: "Proveedor:",
    tabCard: "Perfil",
    tabSysPrompt: "Prompt Personaje",
    tabPrompt: "Prompt Imagen",
    tabJson: "Datos JSON",
    secPsychology: "Psicología",
    labelMbti: "MBTI",
    labelDesire: "Deseo",
    labelFear: "Miedo",
    labelHighConcept: "Alto Concepto",
    labelQuirks: "Peculiaridades",
    secAppearance: "Apariencia",
    secBackground: "Historia",
    labelSecret: "Secreto oscuro",
    labelSysPrompt: "Instrucción del Sistema LLM",
    labelDevGuide: "Guía para desarrolladores",
    textDevGuide: "Esta instrucción configura a los LLM para actuar como este personaje. Pégalo en el campo System Prompt.",
    btnCopy: "Copiar",
    btnCopied: "Copiado",
    btnDownloadMd: "Descargar MD",
    btnDownloaded: "Descargado",
    // Exportación Markdown
    mdBasicInfo: "Información Básica",
    mdAttrHeader: "Atributo",
    mdValueHeader: "Valor",
    mdRace: "Raza",
    mdGender: "Género",
    mdAge: "Edad",
    mdOccupation: "Ocupación",
    mdAlignment: "Alineamiento",
    mdCoreDesire: "Deseo Central",
    mdCoreFear: "Miedo Central",
    mdFlaw: "Defecto de Carácter",
    mdPersonalityKeywords: "Palabras Clave de Personalidad",
    mdOrigin: "Origen",
    mdUnknown: "Desconocido",
    mdSecretWarning: "⚠️",
    mdCharacterSection: "Instrucción de Personaje (System Prompt)",
    mdImageSection: "Prompt de Imagen",
    mdJsonSection: "Datos JSON Sin Procesar",
    mdGeneratedBy: "Generado por CharGen",
    mdGenerateFailed: "Generación fallida",
    // Visual Design Studio
    visualStudioTitle: "Estudio Visual",
    visualUsageGuide: "💡 Guía de Uso",
    visualUsageGuideText: "① Copie el prompt de 'Retrato' en Gemini/MJ/SD para generar el retrato → ② Use la imagen generada como referencia con las plantillas posteriores (Tres Vistas, Desglose de Concepto, etc.) para crear una hoja de diseño completa.",
    visualStyleNotice: "🎨 Nota de Estilo",
    visualStyleNoticeText: "Estilo predeterminado: Arte conceptual de juego universal. Para estilo anime, agregue \"anime style\" a las Palabras Clave al generar el personaje.",
    visualTypes: {
      portrait: "Retrato",
      three_views: "Tres Vistas",
      concept_breakdown: "Desglose Conceptual",
      expression_sheet: "Hoja de Expresiones",
      scale_chart: "Gráfico de Escala",
      action_poses: "Poses de Acción"
    },
    visualDescriptions: {
      portrait: "Retrato estándar del personaje con énfasis en iluminación y detalles faciales.",
      three_views: "Vistas frontal/lateral/trasera para referencia de modelado 3D.",
      concept_breakdown: "Capas de vestuario, accesorios de armas y primeros planos de materiales.",
      expression_sheet: "Expresiones faciales multiángulo mostrando diversas emociones.",
      scale_chart: "Gráfico de comparación de altura estableciendo proporciones corporales.",
      action_poses: "Poses de combate o acción de alta energía mostrando siluetas dinámicas."
    },
    btnGenerateVisual: "Generar Prompt",
    msgVisualGenerating: "Diseñando...",
    msgConsistency: "Basado en [Retrato] para apariencia consistente ✨",
    guideRefPortrait: "Consejo de Uso: Suba la imagen [01. Retrato] como imagen de referencia a la IA junto con el prompt.",
    guideRefSheet: "Consejo de Uso: Recomendado usar [02. Tres Vistas] como referencia (más estructuralmente preciso), o continuar usando el retrato.",
    labelImgPrompt: "Prompt Stable Diffusion / Midjourney",
    textImgGuide: "Optimizado para retratos. Úsalo con Midjourney o Stable Diffusion.",
    labelRawJson: "Datos JSON sin procesar",
    settingsTitle: "Configuración del modelo",
    labelProvider: "Proveedor de IA",
    labelApiKey: "Clave API",
    labelBaseUrl: "URL Base",
    labelModel: "Nombre del modelo",
    localOllama: "Ollama local",
    modelHint: "Consejo: Copie el nombre exacto del modelo de los documentos oficiales",
    btnTest: "Probar conexión",
    btnSave: "Guardar y cerrar",
    statusConnected: "Conectado",
    statusFailed: "Fallido",
    statusTesting: "Probando...",
    worldOptionCustom: "Otro (Entrada manual)",
    placeholderCustomWorld: "ej. Steampunk + Lovecraft, Vida escolar, Roma antigua...",
    worldOptions: {
      fantasy: "Fantasía - Espada y Hechicería",
      cyberpunk: "Cyberpunk - Alta tecnología, baja vida",
      modern: "Moderno - Realista/Misterio",
      space: "Space Opera - Viaje interestelar",
      wasteland: "Post-apocalíptico - Supervivencia",
      wuxia: "Wuxia/Xianxia - Artes marciales",
      lovecraft: "Lovecraftiano - Terror cósmico"
    }
  },
  fr: {
    langName: "Français",
    appTitle: "CharGen",
    appSubtitle: "Beta",
    heroSubtitle: "Entrez des fragments, forgez une âme.",
    modeCustom: "Personnalisé",
    modeRandom: "Aléatoire",
    labelWorld: "Univers",
    labelRole: "Rôle/Identité",
    labelGender: "Genre",
    labelKeywords: "Mots-clés",
    labelSubversion: "Niveau de subversion",
    subversionOptions: {
      ordinary: "Ordinaire - Correspond au stéréotype",
      surprising: "Surprenant - Un ou deux petits rebondissements",
      memorable: "Mémorable - Contradictions claires",
      unconventional: "Non conventionnel - Défie les attentes",
      extreme: "Rebelle extrême - Brise le moule"
    },
    placeholderRole: "ex: Chevalier errant",
    placeholderGender: "ex: Femme",
    placeholderKeywords: "ex: Névrosé, collectionne les pièces...",
    placeholderApiKey: "Coller la clé API",
    placeholderModel: "Entrer le nom complet du modèle, ex. gemini-2.0-flash",
    randomText: "Laissez faire le destin.\nLe système construira une âme unique.",
    btnGenerate: "Forger",
    btnConfigureApiKey: "Configurez d'abord la clé API ⚙️",
    btnGenerating: "Génération...",
    errorApiKey: "Veuillez d'abord configurer la clé API.",
    currentModel: "Modèle actuel:",
    waitingTitle: "En attente",
    waitingDesc: "Configurez d'abord les paramètres via l'icône d'engrenage.",
    loadingText: "Construction des circuits neuronaux...",
    loadingProvider: "Fournisseur:",
    tabCard: "Profil",
    tabSysPrompt: "Prompt Personnage",
    tabPrompt: "Prompt Image",
    tabJson: "Données JSON",
    secPsychology: "Psychologie",
    labelMbti: "MBTI",
    labelDesire: "Désir",
    labelFear: "Peur",
    labelHighConcept: "Haut Concept",
    labelQuirks: "Manies",
    secAppearance: "Apparence",
    secBackground: "Histoire",
    labelSecret: "Secret sombre",
    labelSysPrompt: "Instruction Système LLM",
    labelDevGuide: "Guide développeur",
    textDevGuide: "Cette instruction configure les LLM pour incarner ce personnage. Collez-la dans le champ System Prompt.",
    btnCopy: "Copier",
    btnCopied: "Copié",
    btnDownloadMd: "Télécharger MD",
    btnDownloaded: "Téléchargé",
    // Export Markdown
    mdBasicInfo: "Informations de Base",
    mdAttrHeader: "Attribut",
    mdValueHeader: "Valeur",
    mdRace: "Race",
    mdGender: "Genre",
    mdAge: "Âge",
    mdOccupation: "Profession",
    mdAlignment: "Alignement",
    mdCoreDesire: "Désir Central",
    mdCoreFear: "Peur Centrale",
    mdFlaw: "Défaut de Caractère",
    mdPersonalityKeywords: "Mots-clés de Personnalité",
    mdOrigin: "Origine",
    mdUnknown: "Inconnu",
    mdSecretWarning: "⚠️",
    mdCharacterSection: "Instruction de Personnage (System Prompt)",
    mdImageSection: "Prompt d'Image",
    mdJsonSection: "Données JSON Brutes",
    mdGeneratedBy: "Généré par CharGen",
    mdGenerateFailed: "Échec de génération",
    // Visual Design Studio
    visualStudioTitle: "Studio Visuel",
    visualUsageGuide: "💡 Guide d'Utilisation",
    visualUsageGuideText: "① Copiez le prompt 'Portrait' dans Gemini/MJ/SD pour générer le portrait → ② Utilisez l'image générée comme référence avec les modèles suivants (Trois Vues, Décomposition du Concept, etc.) pour créer une feuille de conception complète.",
    visualStyleNotice: "🎨 Note de Style",
    visualStyleNoticeText: "Style par défaut : Art conceptuel de jeu universel. Pour un style anime, ajoutez \"anime style\" aux Mots-clés lors de la génération du personnage.",
    visualTypes: {
      portrait: "Portrait",
      three_views: "Trois Vues",
      concept_breakdown: "Décomposition Conceptuelle",
      expression_sheet: "Feuille d'Expressions",
      scale_chart: "Graphique d'Échelle",
      action_poses: "Poses d'Action"
    },
    visualDescriptions: {
      portrait: "Portrait de personnage standard mettant l'accent sur l'éclairage et les détails faciaux.",
      three_views: "Vues avant/côté/arrière pour référence de modélisation 3D.",
      concept_breakdown: "Couches de costume, accessoires d'armes et gros plans de matériaux.",
      expression_sheet: "Expressions faciales multi-angles montrant diverses émotions.",
      scale_chart: "Graphique de comparaison de taille établissant les proportions corporelles.",
      action_poses: "Poses de combat ou d'action à haute énergie montrant des silhouettes dynamiques."
    },
    btnGenerateVisual: "Générer le Prompt",
    msgVisualGenerating: "Conception...",
    msgConsistency: "Basé sur [Portrait] pour une apparence cohérente ✨",
    guideRefPortrait: "Astuce d'Utilisation : Téléchargez l'image [01. Portrait] comme image de référence à l'IA avec le prompt.",
    guideRefSheet: "Astuce d'Utilisation : Recommandé d'utiliser [02. Trois Vues] comme référence (plus précis structurellement), ou continuer avec le portrait.",
    labelImgPrompt: "Prompt Stable Diffusion / Midjourney",
    textImgGuide: "Optimisé pour les portraits. À utiliser avec Midjourney ou Stable Diffusion.",
    labelRawJson: "Données JSON brutes",
    settingsTitle: "Configuration du modèle",
    labelProvider: "Fournisseur IA",
    labelApiKey: "Clé API",
    labelBaseUrl: "URL de base",
    labelModel: "Nom du modèle",
    localOllama: "Ollama local",
    modelHint: "Astuce: Copiez le nom exact du modèle depuis la documentation officielle",
    btnTest: "Tester connexion",
    btnSave: "Enregistrer",
    statusConnected: "Connecté",
    statusFailed: "Échec",
    statusTesting: "Test...",
    worldOptionCustom: "Autre (Saisie manuelle)",
    placeholderCustomWorld: "ex. Steampunk + Lovecraft, Vie scolaire, Rome antique...",
    worldOptions: {
      fantasy: "Fantasy - Épée et Magie",
      cyberpunk: "Cyberpunk - High Tech Low Life",
      modern: "Moderne - Réaliste/Mystère",
      space: "Space Opera - Voyage interstellaire",
      wasteland: "Post-apocalyptique - Survie",
      wuxia: "Wuxia/Xianxia - Arts martiaux",
      lovecraft: "Lovecraftien - Horreur cosmique"
    }
  },
  ru: {
    langName: "Русский",
    appTitle: "CharGen",
    appSubtitle: "Бета",
    heroSubtitle: "Введите фрагменты, выкуйте душу.",
    modeCustom: "Свой режим",
    modeRandom: "Случайно",
    labelWorld: "Сеттинг",
    labelRole: "Роль/Личность",
    labelGender: "Пол",
    labelKeywords: "Ключевые слова",
    labelSubversion: "Уровень нестандартности",
    subversionOptions: {
      ordinary: "Обычный - Соответствует стереотипу",
      surprising: "Удивительный - Пара небольших поворотов",
      memorable: "Запоминающийся - Явные противоречия",
      unconventional: "Нетрадиционный - Бросает вызов ожиданиям",
      extreme: "Экстремальный бунтарь - Полностью ломает шаблон"
    },
    placeholderRole: "напр. Странствующий рыцарь",
    placeholderGender: "напр. Женский",
    placeholderKeywords: "напр. Невротик, собирает монеты...",
    placeholderApiKey: "Вставьте API ключ",
    placeholderModel: "Введите полное имя модели, напр. gemini-2.0-flash",
    randomText: "Доверьтесь судьбе.\nСистема создаст уникальную душу с нуля.",
    btnGenerate: "Создать",
    btnConfigureApiKey: "Сначала настройте API Key ⚙️",
    btnGenerating: "Создание...",
    errorApiKey: "Сначала настройте API Key в настройках.",
    currentModel: "Текущая модель:",
    waitingTitle: "Ожидание ввода",
    waitingDesc: "Сначала настройте параметры модели через значок шестеренки.",
    loadingText: "Построение нейронных цепей...",
    loadingProvider: "Провайдер:",
    tabCard: "Профиль",
    tabSysPrompt: "Промпт Персонажа",
    tabPrompt: "Арт Промпт",
    tabJson: "JSON Данные",
    secPsychology: "Психология",
    labelMbti: "MBTI",
    labelDesire: "Желание",
    labelFear: "Страх",
    labelHighConcept: "Высокий Концепт",
    labelQuirks: "Причуды",
    secAppearance: "Внешность",
    secBackground: "История",
    labelSecret: "Темный секрет",
    labelSysPrompt: "Системная инструкция LLM",
    labelDevGuide: "Руководство разработчика",
    textDevGuide: "Эта инструкция настраивает LLM (например, GPT-4) действовать как этот персонаж. Вставьте её в поле System Prompt.",
    btnCopy: "Копировать",
    btnCopied: "Скопировано",
    btnDownloadMd: "Скачать MD",
    btnDownloaded: "Скачано",
    // Экспорт Markdown
    mdBasicInfo: "Основная Информация",
    mdAttrHeader: "Атрибут",
    mdValueHeader: "Значение",
    mdRace: "Раса",
    mdGender: "Пол",
    mdAge: "Возраст",
    mdOccupation: "Профессия",
    mdAlignment: "Мировоззрение",
    mdCoreDesire: "Основное Желание",
    mdCoreFear: "Основной Страх",
    mdFlaw: "Недостаток Характера",
    mdPersonalityKeywords: "Ключевые Черты Личности",
    mdOrigin: "Происхождение",
    mdUnknown: "Неизвестно",
    mdSecretWarning: "⚠️",
    mdCharacterSection: "Инструкция Персонажа (System Prompt)",
    mdImageSection: "Промпт для Изображения",
    mdJsonSection: "Сырые Данные JSON",
    mdGeneratedBy: "Создано CharGen",
    mdGenerateFailed: "Ошибка генерации",
    // Visual Design Studio
    visualStudioTitle: "Визуальная студия",
    visualUsageGuide: "💡 Руководство по использованию",
    visualUsageGuideText: "① Скопируйте промпт 'Портрет' в Gemini/MJ/SD для создания портрета → ② Используйте сгенерированное изображение как референс с последующими шаблонами (Три вида, Детальная разбивка и т.д.) для создания полного дизайн-листа.",
    visualStyleNotice: "🎨 Примечание о стиле",
    visualStyleNoticeText: "Стиль по умолчанию: Универсальный концепт-арт для игр. Для аниме-стиля добавьте \"anime style\" в Ключевые слова при генерации персонажа.",
    visualTypes: {
      portrait: "Портрет",
      three_views: "Три вида",
      concept_breakdown: "Детализация концепта",
      expression_sheet: "Лист выражений",
      scale_chart: "Диаграмма масштаба",
      action_poses: "Боевые позы"
    },
    visualDescriptions: {
      portrait: "Стандартный портрет персонажа с акцентом на освещение и детали лица.",
      three_views: "Вид спереди/сбоку/сзади для 3D-моделирования.",
      concept_breakdown: "Слои костюма, реквизит оружия и крупные планы материалов.",
      expression_sheet: "Выражения лица под разными углами, показывающие различные эмоции.",
      scale_chart: "Диаграмма сравнения роста, устанавливающая пропорции тела.",
      action_poses: "Высокоэнергетические боевые или экшн-позы, демонстрирующие динамичные силуэты."
    },
    btnGenerateVisual: "Создать промпт",
    msgVisualGenerating: "Разработка...",
    msgConsistency: "На основе [Портрета] для единообразного внешнего вида ✨",
    guideRefPortrait: "Совет по использованию: Загрузите изображение [01. Портрет] в качестве референса для ИИ вместе с промптом ниже.",
    guideRefSheet: "Совет по использованию: Рекомендуется использовать [02. Три вида] в качестве референса (более структурно точно), или продолжать использовать портрет.",
    labelImgPrompt: "Промпт для Stable Diffusion / Midjourney",
    textImgGuide: "Оптимизировано для портретов. Используйте с Midjourney или Stable Diffusion.",
    labelRawJson: "Сырые данные JSON",
    settingsTitle: "Настройка модели",
    labelProvider: "AI Провайдер",
    labelApiKey: "API Ключ",
    labelBaseUrl: "Базовый URL",
    labelModel: "Имя модели",
    localOllama: "Локальный Ollama",
    modelHint: "Совет: Скопируйте точное имя модели из официальной документации",
    btnTest: "Проверить",
    btnSave: "Сохранить",
    statusConnected: "Успешно",
    statusFailed: "Ошибка",
    statusTesting: "Тест...",
    worldOptionCustom: "Другое (Ручной ввод)",
    placeholderCustomWorld: "напр. Стимпанк + Лавкрафт, Школьная жизнь, Древний Рим...",
    worldOptions: {
      fantasy: "Фэнтези - Меч и Магия",
      cyberpunk: "Киберпанк - Хай-тек",
      modern: "Современность - Реализм",
      space: "Космоопера - Межзвездные путешествия",
      wasteland: "Постапокалипсис - Выживание",
      wuxia: "Уся/Сянься - Боевые искусства",
      lovecraft: "Лавкрафт - Космический ужас"
    }
  },
  ja: {
    langName: "日本語",
    appTitle: "CharGen",
    appSubtitle: "Beta",
    heroSubtitle: "インスピレーションの断片から、完全な魂を鋳造する。",
    modeCustom: "カスタム",
    modeRandom: "ランダム",
    labelWorld: "世界観設定",
    labelRole: "職業/身分",
    labelGender: "性別",
    labelKeywords: "キーワード/手がかり",
    labelSubversion: "キャラの意外性レベル",
    subversionOptions: {
      ordinary: "平凡 - ステレオタイプ通り",
      surprising: "意外 - 少しの意外性",
      memorable: "印象的 - 明確な内面の矛盾",
      unconventional: "型破り - 期待を大きく裏切る",
      extreme: "極端な反逆者 - 完全に常識を覆す"
    },
    placeholderRole: "例：放浪の騎士",
    placeholderGender: "例：女性",
    placeholderKeywords: "例：神経質、古銭収集が趣味...",
    placeholderApiKey: "APIキーを貼り付け",
    placeholderModel: "完全なモデル名を入力、例：gemini-2.0-flash",
    randomText: "運命に身を任せよう。\nシステムがゼロからユニークな魂を構築します。",
    btnGenerate: "生成開始",
    btnConfigureApiKey: "先にAPIキーを設定してください ⚙️",
    btnGenerating: "生成中...",
    errorApiKey: "設定（歯車アイコン）からAPIキーを設定してください。",
    currentModel: "現在のモデル:",
    waitingTitle: "入力待ち",
    waitingDesc: "右上部からモデルを設定して、生成を開始してください。",
    loadingText: "神経回路を構築中...",
    loadingProvider: "プロバイダー:",
    tabCard: "プロフィール",
    tabSysPrompt: "キャラプロンプト",
    tabPrompt: "画像プロンプト",
    tabJson: "JSONデータ",
    secPsychology: "心理プロファイル",
    labelMbti: "MBTI",
    labelDesire: "願望",
    labelFear: "恐怖",
    labelHighConcept: "ハイコンセプト",
    labelQuirks: "癖",
    secAppearance: "外見の特徴",
    secBackground: "背景ストーリー",
    labelSecret: "隠された秘密",
    labelSysPrompt: "LLMシステム命令",
    labelDevGuide: "開発者ガイド",
    textDevGuide: "この命令はLLM（GPT-4など）にこのキャラクターを演じさせるための設定です。System Promptフィールドに貼り付けてください。",
    btnCopy: "コピー",
    btnCopied: "完了",
    btnDownloadMd: "MDをダウンロード",
    btnDownloaded: "ダウンロード完了",
    // Markdown エクスポート
    mdBasicInfo: "基本情報",
    mdAttrHeader: "属性",
    mdValueHeader: "値",
    mdRace: "種族",
    mdGender: "性別",
    mdAge: "年齢",
    mdOccupation: "職業",
    mdAlignment: "属性",
    mdCoreDesire: "核心的欲望",
    mdCoreFear: "核心的恐怖",
    mdFlaw: "性格の欠点",
    mdPersonalityKeywords: "性格キーワード",
    mdOrigin: "出身地",
    mdUnknown: "不明",
    mdSecretWarning: "⚠️",
    mdCharacterSection: "キャラクター指示 (System Prompt)",
    mdImageSection: "画像プロンプト",
    mdJsonSection: "Raw JSONデータ",
    mdGeneratedBy: "CharGen で生成",
    mdGenerateFailed: "生成失敗",
    // Visual Design Studio
    visualStudioTitle: "ビジュアルスタジオ",
    visualUsageGuide: "💡 使用ガイド",
    visualUsageGuideText: "① 「ポートレート」プロンプトをGemini/MJ/SDにコピーしてポートレートを生成 → ② 生成された画像を参照画像として、後続のプロンプトテンプレート（三面図、詳細分解など）と組み合わせて完全なデザインシートを構築します。",
    visualStyleNotice: "🎨 スタイル注記",
    visualStyleNoticeText: "デフォルトスタイル：汎用ゲームコンセプトアート。アニメスタイルの場合、キャラクター生成時のキーワードに「anime style」を追加してください。",
    visualTypes: {
      portrait: "キャラクター立ち絵",
      three_views: "三面図",
      concept_breakdown: "コンセプト分解",
      expression_sheet: "表情集",
      scale_chart: "スケールチャート",
      action_poses: "アクションポーズ"
    },
    visualDescriptions: {
      portrait: "照明と顔の詳細を強調した標準的なキャラクターポートレート。",
      three_views: "3Dモデリング参照用の正面/側面/背面図。",
      concept_breakdown: "衣装レイヤー、武器小道具、素材のクローズアップ。",
      expression_sheet: "様々な感情を示す多角度の表情。",
      scale_chart: "身体比率を確立する身長比較チャート。",
      action_poses: "ダイナミックなシルエットを示す高エネルギーの戦闘またはアクションポーズ。"
    },
    btnGenerateVisual: "プロンプト生成",
    msgVisualGenerating: "デザイン中...",
    msgConsistency: "[立ち絵]ベースで一貫した外観 ✨",
    guideRefPortrait: "使用のヒント：[01. キャラクター立ち絵]画像を参照画像としてAIにアップロードし、プロンプトと共に使用してください。",
    guideRefSheet: "使用のヒント：[02. 三面図]を参照として使用することをお勧めします（構造的により正確）、または立ち絵を引き続き使用してください。",
    labelImgPrompt: "Stable Diffusion / Midjourney プロンプト",
    textImgGuide: "キャラクターの立ち絵生成に最適化されています。MidjourneyやStable Diffusionで使用してください。",
    labelRawJson: "Raw JSONデータ",
    settingsTitle: "モデル設定",
    labelProvider: "AIプロバイダー",
    labelApiKey: "APIキー",
    labelBaseUrl: "ベースURL",
    labelModel: "モデル名",
    localOllama: "ローカル Ollama",
    modelHint: "ヒント：公式ドキュメントから正確なモデル名をコピーしてください",
    btnTest: "接続テスト",
    btnSave: "保存して閉じる",
    statusConnected: "接続成功",
    statusFailed: "接続失敗",
    statusTesting: "テスト中...",
    worldOptionCustom: "その他 (手動入力)",
    placeholderCustomWorld: "例：スチームパンク+クトゥルフ、学園日常、古代ローマ...",
    worldOptions: {
      fantasy: "ファンタジー - 剣と魔法",
      cyberpunk: "サイバーパンク - ハイテク・ローライフ",
      modern: "現代 - リアリズム/ミステリー",
      space: "スペースオペラ - 星間旅行",
      wasteland: "ポストアポカリプス - 荒廃と生存",
      wuxia: "武侠/仙侠 - 東洋ファンタジー",
      lovecraft: "ラヴクラフト - コズミック・ホラー"
    }
  },
  ko: {
    langName: "한국어",
    appTitle: "CharGen",
    appSubtitle: "Beta",
    heroSubtitle: "영감의 조각으로 완전한 영혼을 주조하세요.",
    modeCustom: "커스텀 모드",
    modeRandom: "완전 랜덤",
    labelWorld: "세계관 설정",
    labelRole: "직업/신분",
    labelGender: "성별",
    labelKeywords: "키워드/단서",
    labelSubversion: "캐릭터 반전 레벨",
    subversionOptions: {
      ordinary: "평범함 - 고정관념에 부합",
      surprising: "의외성 - 작은 반전 하나둘",
      memorable: "인상적 - 명확한 내면 모순",
      unconventional: "파격적 - 기대를 크게 뒤엎음",
      extreme: "극단적 반역 - 완전히 틀을 깸"
    },
    placeholderRole: "예: 방랑 기사",
    placeholderGender: "예: 여성",
    placeholderKeywords: "예: 신경질적임, 오래된 동전 수집...",
    placeholderApiKey: "API 키 붙여넣기",
    placeholderModel: "전체 모델 이름 입력, 예: gemini-2.0-flash",
    randomText: "운명에 맡기세요.\n시스템이 제로부터 독특한 영혼을 구축합니다.",
    btnGenerate: "생성 시작",
    btnConfigureApiKey: "먼저 API Key를 설정하세요 ⚙️",
    btnGenerating: "생성 중...",
    errorApiKey: "먼저 설정(기어 아이콘)에서 API 키를 구성하세요.",
    currentModel: "현재 모델:",
    waitingTitle: "입력 대기 중",
    waitingDesc: "먼저 오른쪽 상단의 기어 아이콘을 클릭하여 모델을 설정하세요.",
    loadingText: "신경 회로 구축 중...",
    loadingProvider: "공급자:",
    tabCard: "프로필",
    tabSysPrompt: "캐릭터 프롬프트",
    tabPrompt: "이미지 프롬프트",
    tabJson: "JSON 데이터",
    secPsychology: "심리 프로필",
    labelMbti: "MBTI",
    labelDesire: "욕망",
    labelFear: "공포",
    labelHighConcept: "하이 컨셉",
    labelQuirks: "버릇",
    secAppearance: "외모 특징",
    secBackground: "배경 이야기",
    labelSecret: "숨겨진 비밀",
    labelSysPrompt: "LLM 시스템 지침",
    labelDevGuide: "개발자 가이드",
    textDevGuide: "이 지침은 LLM(GPT-4 등)이 이 캐릭터를 연기하도록 구성하는 데 사용됩니다. System Prompt 필드에 붙여넣으세요.",
    btnCopy: "복사",
    btnCopied: "완료",
    btnDownloadMd: "MD 다운로드",
    btnDownloaded: "다운로드 완료",
    // Markdown 내보내기
    mdBasicInfo: "기본 정보",
    mdAttrHeader: "속성",
    mdValueHeader: "값",
    mdRace: "종족",
    mdGender: "성별",
    mdAge: "나이",
    mdOccupation: "직업",
    mdAlignment: "성향",
    mdCoreDesire: "핵심 욕망",
    mdCoreFear: "핵심 공포",
    mdFlaw: "성격 결함",
    mdPersonalityKeywords: "성격 키워드",
    mdOrigin: "출신지",
    mdUnknown: "알 수 없음",
    mdSecretWarning: "⚠️",
    mdCharacterSection: "캐릭터 지침 (System Prompt)",
    mdImageSection: "이미지 프롬프트",
    mdJsonSection: "Raw JSON 데이터",
    mdGeneratedBy: "CharGen으로 생성됨",
    mdGenerateFailed: "생성 실패",
    // Visual Design Studio
    visualStudioTitle: "비주얼 스튜디오",
    visualUsageGuide: "💡 사용 가이드",
    visualUsageGuideText: "① '초상화' 프롬프트를 Gemini/MJ/SD에 복사하여 초상화 생성 → ② 생성된 이미지를 참조 이미지로 사용하여 후속 프롬프트 템플릿(삼면도, 상세 분석 등)과 결합하여 완전한 디자인 시트를 구축합니다.",
    visualStyleNotice: "🎨 스타일 안내",
    visualStyleNoticeText: "기본 스타일: 범용 게임 컨셉 아트. 애니메이션 스타일을 원하시면 캐릭터 생성 시 키워드에 \"anime style\"을 추가하세요.",
    visualTypes: {
      portrait: "캐릭터 초상화",
      three_views: "삼면도",
      concept_breakdown: "컨셉 분해",
      expression_sheet: "표정 시트",
      scale_chart: "스케일 차트",
      action_poses: "액션 포즈"
    },
    visualDescriptions: {
      portrait: "조명과 얼굴 디테일을 강조한 표준 캐릭터 초상화.",
      three_views: "3D 모델링 참조를 위한 정면/측면/후면도.",
      concept_breakdown: "의상 레이어, 무기 소품 및 재질 클로즈업.",
      expression_sheet: "다양한 감정을 보여주는 다각도 표정.",
      scale_chart: "신체 비율을 확립하는 키 비교 차트.",
      action_poses: "역동적인 실루엣을 보여주는 고에너지 전투 또는 액션 포즈."
    },
    btnGenerateVisual: "프롬프트 생성",
    msgVisualGenerating: "디자인 중...",
    msgConsistency: "[초상화] 기반 일관된 외관 ✨",
    guideRefPortrait: "사용 팁: [01. 캐릭터 초상화] 이미지를 참조 이미지로 AI에 업로드하고 프롬프트와 함께 사용하세요.",
    guideRefSheet: "사용 팁: [02. 삼면도]를 참조로 사용하는 것이 좋습니다(구조적으로 더 정확함), 또는 초상화를 계속 사용하세요.",
    labelImgPrompt: "Stable Diffusion / Midjourney 프롬프트",
    textImgGuide: "캐릭터 초상화 생성에 최적화되었습니다. Midjourney 또는 Stable Diffusion에서 사용하세요.",
    labelRawJson: "Raw JSON 데이터",
    settingsTitle: "모델 구성",
    labelProvider: "AI 공급자",
    labelApiKey: "API 키",
    labelBaseUrl: "기본 URL",
    labelModel: "모델 이름",
    localOllama: "로컬 Ollama",
    modelHint: "팁: 공식 문서에서 정확한 모델 이름을 복사하세요",
    btnTest: "연결 테스트",
    btnSave: "저장 및 닫기",
    statusConnected: "연결 성공",
    statusFailed: "연결 실패",
    statusTesting: "테스트 중...",
    worldOptionCustom: "기타 (직접 입력)",
    placeholderCustomWorld: "예: 스팀펑크+러브크래프트, 학원 일상, 고대 로마...",
    worldOptions: {
      fantasy: "판타지 - 검과 마법",
      cyberpunk: "사이버펑크 - 하이테크 로우라이프",
      modern: "현대 - 리얼리즘/미스터리",
      space: "스페이스 오페라 - 성간 여행",
      wasteland: "포스트 아포칼립스 - 생존",
      wuxia: "무협/선협 - 동양 판타지",
      lovecraft: "러브크래프트 - 코스믹 호러"
    }
  }
};

// 辅助函数：获取翻译文本
export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['zh']?.[key] || key;
};

// 支持的语言列表
export const supportedLanguages = Object.keys(translations);
